import { Researcher } from "@features/admin/researcher-management/models/researcher.model";

export function formatPhone(raw?: string | null): string {
  if (!raw) return '';
  // keep only digits
  const digits = (raw.match(/\d/g) || []).join('');
  // handle NANP: allow leading 1 (country code)
  const d = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (d.length === 10) {
    return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  }
  // fallback to original if we can't confidently format
  return raw;
}

export function formatResearcher(r: Researcher | null | undefined): string {
  if (!r) return '';
  const hasEmail = !!r.email;
  const hasPhone = !!r.phone;

  if (!hasEmail && !hasPhone) {
    return `${r.lastName}, ${r.firstName}`;
  }

  const phone = hasPhone ? formatPhone(r.phone!) : '';
  const contact = [r.email || '', phone].filter(Boolean).join(' | ');
  return `${r.lastName}, ${r.firstName} (${contact})`;
}

/** For autocomplete displayWith etc. */
export function displayResearcher(r: Researcher | string | null): string {
  // If user typed but didn't select from autocomplete, r will be a string
  if (typeof r === 'string') return ''; // Return empty to clear the display

  return formatResearcher(r);
}
